module.exports = __webpack_public_path__ + "static/avatar-of-man-with-laptop-showing-thumbs-up-741f31af9bc864dabc0eb8a37b08585e.png";